import { commonOptions, EnableStatus } from '@/config'

import { App, HostApp, type DataOptionItem, type PageContext } from '@zto/zpage'
import { deepFilter } from './common'

/**
 * 获取文件URL列表
 * @param fileIds
 * @returns
 */
export function getSpmFileUrls(fileIds: string[]) {
  return HostApp.app!.request({
    api: '/sys/admin/file/getSpmFileUrls',
    params: {
      fileNameList: fileIds
    }
  })
}

/** 获取通用选项Label */
export function getCommonOption(optionName: string | DataOptionItem[], value: any, prop?: string) {
  const optionItems = typeof optionName === 'string' ? (commonOptions as any)[optionName] : optionName
  if (!optionItems) return null

  const optionItem = optionItems.find((it: any) => it.value === value)
  if (!prop || !optionItem) return optionItem
  return optionItem[prop]
}

/** 获取通用选项Label */
export function getCommonOptionLabel(optionName: string | DataOptionItem[], value: any, defaultLabel = '') {
  const option = getCommonOption(optionName, value)

  if (!option) return defaultLabel

  return option.label
}

/** 获取表格状态查询 */
export function getTableStatusEditor(options: any) {
  const opts = { ...options }

  const activeValue = opts.activeValue || EnableStatus.ENABLE
  const inactiveValue = opts.inactiveValue || EnableStatus.DISABLE

  return {
    itemType: 'switch',
    noPadding: true,
    activeValue,
    inactiveValue,
    beforeChange: async (model: any, { app }: PageContext) => {
      await app.ui.showMessageBox({
        boxType: 'confirm',
        message: '是否确定修改'
      })

      // 设置为更改后的状态
      const newStatus = model.status === activeValue ? inactiveValue : activeValue

      let apiParams = opts.apiParams
      if (typeof apiParams === 'function') {
        apiParams = await apiParams(model)
      }

      await app.request({
        api: opts.api,
        data: { status: newStatus, ...apiParams }
      })

      app.ui.showMessage({ type: 'success', message: '更新状态成功' })

      // 无论成功失败都触发页面查询
      app.triggerPageSearch()

      return true
    }
  }
}

/**
 * 清理提交数据
 * 过滤内部临时数据 （以"_"或"__"开头的数据）
 */
export function filterSubmitData(submitData: any) {
  const result = deepFilter(submitData, (obj: any, key: any) => {
    if (typeof key === 'string' && key.startsWith('_')) {
      return false
    }
  })

  return result
}
